// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1u755","info":"PatientInfo_info__3LnX8"};